import { Expose, Transform } from "class-transformer";
import { formatISO, startOfMonth, subYears } from "date-fns";
import { observable } from "mobx";

export default class AdminStatisticsFilter {
  @observable
  period?: Number = 60;

  @observable
  @Expose({ name: "registered_from" })
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument
  @Transform(value => value && formatISO(value, { representation: "date" }))
  registeredFrom?: Date = startOfMonth(subYears(new Date(), 1));

  @observable
  @Expose({ name: "registered_to" })
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument
  @Transform(value => value && formatISO(value, { representation: "date" }))
  registeredTo?: Date = new Date();

  static fromObject(obj: Partial<AdminStatisticsFilter>): AdminStatisticsFilter {
    const filter = new AdminStatisticsFilter();
    Object.assign(filter, obj);
    return filter;
  }
}
